import { TranslateService } from '@ngx-translate/core';
import { Component, ElementRef, EventEmitter, inject, OnInit, Output, ViewChild, ChangeDetectorRef, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { BaseService } from '../../service/base.service';
import { CustomerProgressDialogComponent } from './customer-progress-dialog/customer-progress-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { EmployeeCheckInOutComponent } from '../../../pages/human-resources/employee-check-in-out/employee-check-in-out.component';
import { Router } from '@angular/router';
import { TourService } from 'ngx-ui-tour-md-menu';
import { GuidelineService } from '../../service/guideline.service';
import { UserTypeService } from '../../../core/services';
import { ThemeService } from '../../../pages/theme/services/theme.service';
import { GuidanceService } from '../../../core/services/guidance.service';
import { VisitorChatbotService } from '../../services/visitor-chatbot.service';
import { Observable, Subscription } from 'rxjs';
import { PwaInstallPromptService } from '../../service/pwa-install-prompt.service';
import { SharedDialogComponent } from '../shared-dialog/shared-dialog.component';
import { CustomConnectionService } from '../../service/custom-connection.service';


// import { map } from "rxjs/operators";
import { WifiConnectionComponent } from "./wifi-connection/wifi-connection.component";
import { MatSnackBar } from '@angular/material/snack-bar';
// import {LanguagesComponent} from "./languages/languages.component";

// import { SnackService } from '../../../shared/components/snack/snack.service';
// import { SubscriptionPackagesService } from '../../../pages/setup/subscription-settings/subscription-packages/subscription-packages.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(WifiConnectionComponent) wifiComp!: WifiConnectionComponent;
  @Output() toggle = new EventEmitter<any>();
  public width: number;
  public screenWidth: any;
  empImage: string;
  headerStyle = this._base.headerStyle;
  prodHeaderStyle = this._base.prodHeaderStyle;
  production = this._base.production;
  sidenav = true;
  userTypes = JSON.parse(localStorage.getItem('CURRENT_USER')).userTypes?.map((userType) => userType.code);
  currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
  showAttendanceIcon: boolean = this.userTypes.includes('EMP') || this.userTypes.includes('SUPERVISOR') || this.userTypes.includes('MANAGER') || this.userTypes.includes('CUST');
  freeDaysCountdown: number | null = null;
  public tourService = inject(TourService);
  activeItem: string | null = null;
  // Mobile responsive properties
  isMobile = false;
  isDropdownOpen = false;

  // PWA install state
  showPwaInstallAction = false;
  manualInstallOnly = false;
  private readonly subscriptions = new Subscription();

  // Guidance visibility observable
  isGuidanceVisible$: Observable<boolean>;

  // Local guidance visibility state - updated reactively for immediate UI updates
  isGuidanceVisible: boolean = true;

  calcHeader() {
    const _sideNav = document.getElementById('pagesSideNavigation');
    const sideNav: HTMLElement = _sideNav as HTMLElement;
    this.width = screen.width - sideNav.clientWidth;
  }
  constructor(public _translate: TranslateService,
    private _base: BaseService,
    public guidelineService: GuidelineService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router,
    public userType: UserTypeService,
    public themeService: ThemeService,
    private guidanceService: GuidanceService,
    private cdr: ChangeDetectorRef,
    private visitorChatbotService: VisitorChatbotService,
    private readonly pwaInstallPromptService: PwaInstallPromptService,
    private connectionService: CustomConnectionService

  ) {
    this.empImage = this.production ? 'assets/images/icons/finger_prod.png' : 'assets/images/icons/finger_dev.png';
    this.isGuidanceVisible$ = this.guidanceService.isGuidanceVisible$;
    // Subscribe to guidance visibility changes and update state immediately
    this.subscriptions.add(
      this.guidanceService.isGuidanceVisible$.subscribe({
        next: (visible) => {
          this.isGuidanceVisible = visible;
          this.cdr.detectChanges();
        }
      })
    );

  }
  onFreeTrialClick(): void {
    const daysLeft = this.freeDaysCountdown ?? this.currentUser.remainingDay;
    const totalDays = Number(this.currentUser?.freeDays) || 14;

    this.dialog.open(SharedDialogComponent, {
      data: {
        title: 'HEADER.FREE_TRIAL_DIALOG.TITLE',
        translateText: 'HEADER.FREE_TRIAL_DIALOG.DESCRIPTION',
        translateParams: {
          days: daysLeft,
          totalDays,
        },
      },
      panelClass: 'shared-dialog-panel',
      width: '520px',
      maxWidth: '90vw',
      autoFocus: false,
    });
  }


  toggleTheme() {
    this.themeService.toggleTheme();
  }


  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.checkMobileView();
    this.calculateFreeDaysCountdown();
    if (
      !this.currentUser ||
      this.currentUser.showTutorialGuide == null ||
      this.currentUser.showTutorialGuide === true
    ) {
      this.guidelineService.start(true);
    }

    this.observePwaInstallState();
  }

  private calculateFreeDaysCountdown(): void {
    const startDate = this.currentUser?.startDateToFreePackage;
    const freeDays = this.currentUser?.freeDays;
    if (!startDate || !freeDays || isNaN(Number(freeDays))) {
      this.freeDaysCountdown = null;
      return;
    }

    const start = new Date(startDate);
    if (isNaN(start.getTime())) {
      this.freeDaysCountdown = null;
      return;
    }

    const today = new Date();
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const elapsed = Math.floor((today.getTime() - start.getTime()) / millisecondsPerDay);
    const remaining = Math.max(Math.ceil(freeDays - Math.max(elapsed, 0)), 0);
    this.freeDaysCountdown = remaining;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
    this.checkMobileView();
  }

  private checkMobileView(): void {
    this.isMobile = this.screenWidth <= 768;
  }

  @ViewChild('fixedHeader') fixedHeader: ElementRef;

  ngAfterViewInit() {
    // this.width = this.fixedHeader.nativeElement.offsetWidth - 217;
    this.calcHeader();
  }


  toggleSideNav() {
    this.toggle.emit();
    this.calcHeader();
    this.sidenav = !this.sidenav;
  }
  openCustomerProgressDialog() {
    const dialogRef = this.dialog.open(CustomerProgressDialogComponent, {
      position: { right: '0', top: '0' },
      height: 'auto',
      width: '400px',
      maxWidth: '400px',
      maxHeight: '100vh',
      panelClass: 'progress_dialog',
      hasBackdrop: true,
      disableClose: false,
      autoFocus: false,
      restoreFocus: false
    });
    console.log(dialogRef)
  }

  openAttendancePanel() {
    this.dialog.open(EmployeeCheckInOutComponent).addPanelClass('attendance-dialog-container');
  }

  // openSub() {
  //   this.router.navigate(['/pages/invoices/sub-prices']);
  // }

  // openSub() {
  //   if (this.userTypes.includes('CUST')) {
  //     this.router.navigate(['/pages/invoices/sub-prices']);
  //   } else if (this.userTypes.includes('ADMIN')) {
  //     this.router.navigate(['/pages/invoices/admin-sub-prices']);
  //   } else {
  //     console.warn('User type not handled in openSub');
  //   }
  // }
  openSub() {
    const branchConfig = JSON.parse(localStorage.getItem('BRANCH_CONFIG'));
    if (this.userTypes.includes('CUST')) {
      this.router.navigate(['/pages/invoices/sub-prices']);
    } else if (this.userTypes.includes('ADMIN')) {
      if (branchConfig && branchConfig.id) {
        this.router.navigate(['/pages/invoices/admin-sub-prices']);
      } else {
        console.warn('BRANCH_CONFIG is not set properly');
        this.router.navigate(['/pages/invoices/admin-sub-prices']); // أو إظهار رسالة تحذير
      }
    } else {
      console.warn('User type not handled in openSub');
    }
  }

  /**
   * Toggle guidance visibility
   */
  toggleGuidance(): void {
    this.guidanceService.toggleGuidance();
  }

  /**
   * Run the guided tour from the beginning
   */
  runGuideTour(): void {
    this.guidelineService.start();
  }

  /**
   * Handle AI Assistant icon click
   */
  onAiAssistantClick(): void {
    const currentRoute = this.router.url;
    this.visitorChatbotService.openChatWithPageContext(currentRoute, 'hikma');
  }

  /**
   * Toggle mobile dropdown menu
   */
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
   * Close dropdown when clicking outside
   */
  closeDropdown(): void {
    this.isDropdownOpen = false;
    console.log('closed')
  }

  /**
   * Get current theme class for dropdown
   */
  get dropdownThemeClass(): string {
    return this.themeService.isDarkMode ? 'dark-theme' : 'light-theme';
  }

  onInstallAppClick(): void {
    const instructionKey = this.pwaInstallPromptService.getInstallGuideKey();
    this.dialog.open(SharedDialogComponent, {
      data: {
        title: 'HEADER.INSTALL_GUIDE.TITLE',
        translateText: instructionKey
      },
      panelClass: 'shared-dialog-panel',
      width: '520px',
      autoFocus: false
    });
  }

  get isOnline(): boolean {
    return this.connectionService.isConnected;
  }

  clearPwaCache(): void {
    // Do a real network check before clearing cache
    fetch('https://www.google.com/favicon.ico', { mode: 'no-cors', cache: 'no-store' })
      .then(() => {
        // Online confirmed - proceed with clearing cache
        if ('caches' in window) {
          caches.keys().then(names => {
            const deletePromises = names.map(name => caches.delete(name));
            Promise.all(deletePromises).then(() => {
              this.snackBar.open(
                this._translate.instant('HEADER.CACHE_CLEARED'),
                this._translate.instant('COMMON.CLOSE'),
                { duration: 3000 }
              );
              setTimeout(() => location.reload(), 1000);
            });
          });
        } else {
          location.reload();
        }
      })
      .catch(() => {
        // Offline - do nothing
        console.log('Cannot clear cache: device is offline');
      });
  }

  private observePwaInstallState(): void {
    this.subscriptions.add(
      this.pwaInstallPromptService.installAvailable$.subscribe((available) => {
        this.showPwaInstallAction = available || this.pwaInstallPromptService.isManualInstallOnly;
      })
    );
    this.subscriptions.add(
      this.pwaInstallPromptService.manualInstallOnly$.subscribe((manualOnly) => {
        this.manualInstallOnly = manualOnly;
        if (manualOnly) {
          this.showPwaInstallAction = true;
        } else if (!this.pwaInstallPromptService.isInstallAvailable) {
          this.showPwaInstallAction = false;
        }
      })
    );
    this.subscriptions.add(
      this.pwaInstallPromptService.installed$.subscribe((installed) => {
        if (installed) {
          this.showPwaInstallAction = false;
          this.manualInstallOnly = false;
        }
      })
    );
  }

}
